import React from "react";

import { Box, styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import Timeline from "Components/Generic/TimeLine";
import { formatInTimeZone } from "date-fns-tz";
import { VideoTime, User } from "iconsax-react";

import { Cronjob } from "Models/cronjob";

interface EmailActivitiesSectionProps {
  cronJob: Cronjob;
}

const Title = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.gray600,
}));

const Subtitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: colors.gray600,
}));

export const EmailActivitiesSection = (props: EmailActivitiesSectionProps) => {
  const { cronJob } = props;
  return (
    <Timeline
      useBrandColor
      renderTitle={(item) => <Title>{item.action}</Title>}
      renderSubtitle={(item) => (
        <Box display="flex" gap="24px" paddingTop="8px" paddingBottom="8px">
          <Box display="flex" gap="8px" alignItems="center">
            <VideoTime variant="Outline" size={12} />

            <Subtitle>
              {item.updatedAt &&
                formatInTimeZone(item.updatedAt, "UTC", "dd/MM/yyyy, hh:mm a 'UTC'")}
            </Subtitle>
          </Box>

          <Box display="flex" gap="8px" alignItems="center">
            <User variant="Outline" size={12} />

            <Subtitle>
              {cronJob.cronjobContacts?.map((contacts) => contacts.user?.fullName).join(", ")}
            </Subtitle>
          </Box>
        </Box>
      )}
      icon={
        <div
          style={{
            width: "8px",
            height: "8px",
            backgroundColor: colors.brandBlue500,
            borderRadius: "100%",
          }}
        />
      }
      items={cronJob.histories?.filter((history) => history.action.toLowerCase() === "sent") || []}
      iconDotVariant="outlined"
    />
  );
};
